import {EventEmitter, Inject, Injectable} from "@angular/core";
import {NgbModal, NgbModalConfig, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {TranslateService} from "@ngx-translate/core";
import {Observable} from "rxjs"
import {HttpClient} from "@angular/common/http";
import * as PubSub from 'pubsub-js'
import {PubsubEnum} from "../../enums/pubsub.enum";
import { ToastService } from "../toast/toast.service";
import {environment} from "../../../../environments/environment";
import {TokenCancelComponent} from "../../../components/token-cancel/token-cancel.component";

@Injectable({providedIn: 'root'})
export class TokenCancelService {

  private baseEndpoint: string;
  private modalRef!: NgbModalRef;
  public showContactGacModal: boolean = false;
  public closeModalTokenCancel: EventEmitter<void> = new EventEmitter<void>();
  public tokenBlockError: boolean = false;

  constructor(private modalService: NgbModal,
    private http: HttpClient,
    private modalConfig: NgbModalConfig,
    private translate: TranslateService,
    private toastService: ToastService,

    ) {
      this.baseEndpoint = environment.apiUser
      modalConfig.backdrop = 'static';
      modalConfig.keyboard = true;
  }

  open(fromInside: boolean = false) {
    this.translate.get("UI-CANCEL-TOKEN-MODAL").subscribe(message => {
      this.configModal();
      this.modalRef.componentInstance.modalCancelTokenMessage = message;
    })
    this.sentEmailCode().subscribe({
      next: value => {
        this.toastService.showToast(value.message, "success", "Success")
        return
      },
      error: err => {
        if (err.error.errorCode === "USR02") {
          console.log(err)
          this.toastService.showToast(`${err.error.errorDescription}, please try again`, "error", "Error")
          return;
        } else if (err.error.errorCode == "USR05") {
          this.toastService.showToast(err.error.errorDescription, "error", "Error")
          return;
        } else if (err.error.errorCode === "USR06") {
          this.toastService.showToast(err.error.errorDescription, "error", "Error")
          this.close()
          return;
        }

      },
    })


  }
//TODO: transformarlo a un servicio
  sentEmailCode(): Observable<any> {
    return this.http.get<any>(`${this.baseEndpoint}/token/cancel/email`)
  }

  validateCode(code: string): Observable<any> {
    return this.http.post<any>(`${this.baseEndpoint}/token/cancel`, {
      code
    })
  }

  configModal() {
    this.modalRef = this.modalService.open(TokenCancelComponent);
  }

  close() {
    PubSub.publish(PubsubEnum.CLOSE_CANCELTOKEN_MODAL);
    this.closeModalTokenCancel.emit();
    if (this.modalRef) {
      this.modalRef.close();
    }
  }

  closeWithRef(modalRef: any) {
    if (modalRef) {
      this.modalRef.close();
    }
  }
}
